import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-room-type',
  templateUrl: './room-type.component.html',
  styleUrls: ['./room-type.component.css']
})
export class RoomTypeComponent implements OnInit {

  model = { 'table_name': 'room_type', 'room_type_id': '0', 'room_type': '', 'bed_num': '', 'comment': '' };

  Success_Msg; Error_Msg; Room_Type_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<RoomTypeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Room_Type_Msg').subscribe((res: string) => {
      this.Room_Type_Msg = res;
    });

  }

  ngOnInit() {
    if (this.dialog_data != null)
      this.model = this.dialog_data;
  }

  add() {
    if (this.model['room_type'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['room_type_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'room_type_id': this.model['room_type_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['room_type'] == '') {
      alert(this.Room_Type_Msg);
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }


}
